export const LOCALE_STORAGE_KEY = "lucentia_locale";

export const SUPPORTED_LOCALES = ["es", "en"] as const;
export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

export function isAppLocale(value: string): value is AppLocale {
  return SUPPORTED_LOCALES.includes(value as AppLocale);
}

export function getStoredLocale(): AppLocale {
  if (typeof window === "undefined") return "es";
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (stored === "en") return "en";
  } catch {
    /* private mode / blocked storage */
  }
  return "es";
}

export function localeToHtmlLang(locale: AppLocale): string {
  return locale === "en" ? "en" : "es";
}

export function localeToDateLocale(locale: AppLocale): string {
  return locale === "en" ? "en-GB" : "es-ES";
}
